<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction/>
      <div class="section-body">
        
        <DataFilter :gridId="gridId" :isExport="false" :hasNew="true" newLink="/LeaveForm/request"></DataFilter>
        <SlickGrid :gridId="gridId" :editable="false" :frozenColumn="2" :isAutoInitData="true" baseUrl="/leave_form"/>
      </div>
    </section>
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";

export default {
  title: "Leave Form List",
  access_code: "L_LIST01",
  icon: "fas fa-calendar-alt fa-fw",
  components: {},
  order:3,
  data() {
    return {
      gridId: "list01",
      formData: {
        staff_name: ""
      }
    };
  },
  created() {
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),

    grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    }
  },
  mounted() {},
  methods: {
    ...mapActions("grid", ["actionResetGrid", "actionSetGrid", "actionRequest"])
  }
};
</script>

<style scoped>
.section-body{
  padding-top:100px
}
</style>